import type { TEmailBuilderPreviewViewport } from "redux/reducers/emailBuilder/emailBuilder";

export const EMAIL_BUILDER_PREVIEW_CONTENT_WIDTH_PX = 600;

export const EMAIL_BUILDER_PREVIEW_MOBILE_VIEWPORT_WIDTH_PX = 375;

export const EMAIL_BUILDER_PREVIEW_IFRAME_SANDBOX =
  "allow-same-origin allow-popups allow-popups-to-escape-sandbox";

/** Default loading shell height when no measured preview height is cached yet. */
export const EMAIL_BUILDER_PREVIEW_LOADING_MIN_HEIGHT_PX = 480;

export function resolveEmailBuilderPreviewFrameMaxWidth(
  viewport: TEmailBuilderPreviewViewport,
): number | undefined {
  if (viewport === "mobile") {
    return EMAIL_BUILDER_PREVIEW_MOBILE_VIEWPORT_WIDTH_PX;
  }

  return undefined;
}
